class DZModelHomestayBase{
    /**
     * 主键
     */
    id = "";

    /**
     * 信息标题
     */
    title = "";

    /**
     * 列表图片ID
     */
    listCoverId = "";

    /**
     * 介绍信息
     */
    describe = "";

    /**
     * 土地大类ID
     */
    bigType = "";

    /**
     * 土地小类ID
     */
    smallType = "";

    /**
     * 详细地址ID
     */
    addressId = "";

    /**
     * 土地价格
     */
    price = "";

    /**
     * 价格单位ID
     */
    priceUnit = "";

    /**
     * 用途
     */
    purpose = "";

    /**
     * 房屋类型
     */
    houseType = "";

    /**
     * 总面积
     */
    totalArea = "";

    /**
     * 总面积单位
     */
    totalAreaUnit = "";

    /**
     * 房屋面积
     */
    houseArea = "";

    /**
     * 房屋面积单位ID
     */
    houseAreaUnit = "";

    /**
     * 租赁方式ID
     */
    leasingMethod = "";

    /**
     * 住宿容纳
     */
    accommodate = "";

    /**
     * 有无厕所：0-没有，1-有
     */
    toilet = "";

    /**
     * 厕所类型ID
     */
    toiletType = "";

    /**
     * 房屋朝向
     */
    houseOrientation = "";

    /**
     * 装修程度ID
     */
    decorationLevel = "";

    /**
     * 层数
     */
    floorNum = "";

    /**
     * 水电费
     */
    waterElectricityFees = "";

    /**
     * 配套设施ID，多个以逗号隔开
     */
    supportingFacilities = "";

    supportingFacilitiesArr = []
    /**
     * 民宿图片ID，多个逗号隔开
     */
    imageIds = "";

    /**
     * 联系人ID
     */
    contactsId = "";

    /**
     * 标签ID，多个逗号隔开
     */
    label = "";

    /**
     * 是否被代理：0-没有代理，1-已被代理
     */
    isAgent = "";

    /**
     * 发布状态：0-待审核，1-待交易，2-审核未通过，3-暂停，4-已过期，5-已交易
     */
    status = "";

    /**
     * 更新用户ID
     */
    updateBy = "";

    /**
     * 更新时间
     */
    updateTime = "";

    /**
     * 发布用户ID
     */
    createBy = "";

    /**
     * 创建时间
     */
    createTime = "";
}export default DZModelHomestayBase